import AddWorkShift from './Modal/AddWorkShift';
import { permissionObj } from '../../../../Helpers/permission';
import DeleteModal from '../../../Modals/DeleteModal';
import SearchSimple from '../../../../components/SearchSimples/SearchSimple';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import { TrashOutlineIcon, AddIcon } from '../../../../components/buttons/IconButtons';
import HeadTittle from '../../../../components/HeadTittle';
import NotInformation from '../../../../components/NotInformation';
import WorkshiftFunctionality from './Functionality/WorkshiftPanelApp';
import CustomExpandableTable from '../../../../components/table/CustomExpandableTable';

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 * @returns {JSX.Element}
 * @constructor
 */
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 * @returns {JSX.Element}
 * @constructor
 */

const WorkShiftPanel = () => {
    const {
        t,
        DEV,
        permission,
        workShiftModalShow,
        setWorkShiftModalShow,
        deleteShow,
        setDeleteShow,
        setModified,
        updateData,
        setUpdateData,
        selectedList,
        setSelectedList,
        setIsAllChecked,
        handleDeleteAll,
        handleCheckboxChange,
        deleteWorkShift,
        title_modal,
        element_modal,
        option,
        contractorId,
        supplierId,
        setSearch,
        simpleSearch,
        setSimpleSearch,
        searchElement,
        setSearchElement,
        pagination,
        setResultsToShow,
        resultsToShow,
        columns,
        renderExpandedRow,
        renderOptionsMenu,
        handleRowExpand,
        rowsPerPage,
        setBodyForExport,
    } = WorkshiftFunctionality();

    return (
        <>
            <HeadTittle name={'work_shift_panel'}>
                <>
                    {DEV || permission?.includes(permissionObj?.WEB_WORK_SHIFT_CREATE) ? (
                        <ButtonAction
                            id='btn_wsp_add'
                            name='create'
                            className='btn-icon-add'
                            Icon={AddIcon}
                            onClick={() => {
                                setWorkShiftModalShow(true);
                            }}
                        />
                    ) : null}

                    {DEV || permission?.includes(permissionObj?.WEB_WORK_SHIFT_DELETE) ? (
                        <ButtonAction
                            id='btn_wsp_delete'
                            name='delete'
                            className='btn-icon-delete'
                            disabled={selectedList?.length === 0}
                            onClick={() => {
                                setDeleteShow(true);
                            }}
                            Icon={TrashOutlineIcon}
                        />
                    ) : null}
                </>
            </HeadTittle>
            <SearchSimple
                id='txt_wsp_search_simple'
                setBodyForExport={setBodyForExport}
                setSearchResults={setResultsToShow}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                contractorId={contractorId}
                supplierId={supplierId}
            />
                {resultsToShow?.content?.length > 0 ? (
                    <>
                        {/**Done*/}
                        <CustomExpandableTable
                            columns={columns}
                            rows={resultsToShow?.content || []}
                            renderExpandedRow={renderExpandedRow}
                            renderOptionsMenu={renderOptionsMenu}
                            onRowExpand={handleRowExpand}
                            selectedList={selectedList}
                            handleCheckboxChange={handleCheckboxChange}
                            handleDeleteAll={handleDeleteAll}
                        />
                        {pagination()}
                    </>
                ) : (
                     <NotInformation
                    card={true}
                    text={typeof resultsToShow?.content === 'undefined' ? t('loading') : t('no_workshift')}
                    showButton={DEV || permission?.includes(permissionObj?.WEB_WORK_SHIFT_CREATE)}
                    buttonId={'btn_wsp_link_create'}
                    buttonTrans={'add_new_workshift'}
                    buttonOnclick={() => {
                        setWorkShiftModalShow(true);
                    }}
                />
                )}

            {workShiftModalShow &&
                <AddWorkShift
                    title={''}
                    check='false'
                    setModified={setModified}
                    data={updateData}
                    show={workShiftModalShow}
                    onHide={() => {
                        setWorkShiftModalShow(false);
                        setUpdateData(null);
                    }}
                />
            }
            <DeleteModal
                show={deleteShow}
                onHide={() => setDeleteShow(false)}
                data={selectedList}
                onClickFn={() => deleteWorkShift(selectedList)}
                title_modal={title_modal}
                element_modal={element_modal}
                isReset={setSelectedList}
                isAllReset={setIsAllChecked}
            />
        </>
    );
};

export default WorkShiftPanel;
